import React, { useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { List } from 'immutable';
import { addQueueWaveMappings } from 'flow/actions/pbx-actions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import { QueueKey } from 'flow/types/EntityKeys';
import { QueueMemberDto, QueueWave } from 'flow/types/Queue';
import { TypedMap } from 'flow/types/TypedMap';

interface Props {
    queueKey?: QueueKey;
    queueWaves?: List<TypedMap<QueueWave>>;
    members?: QueueMemberDto[];
}

const AddQueueWaveMemberModal = ({ queueKey, queueWaves, members }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const [selectedQueueWave, setSelectedQueueWave] = useState('');

    return (
        <BaseModal
            open={true}
            header={i18next.t('Queue.HandleMembers.SelectGroup')}
            confirmButtonText={i18next.t('Queue.HandleMembers.Add')}
            onSubmit={
                selectedQueueWave
                    ? () => {
                          dispatch(
                              addQueueWaveMappings(
                                  queueKey,
                                  selectedQueueWave,
                                  members,
                              ),
                          );
                      }
                    : null
            }
        >
            <div>
                {queueWaves.isEmpty() ? (
                    <span>
                        {i18next.t(
                            'Queue.HandleMembers.DelayedHuntGroup.Group_warning',
                        )}
                    </span>
                ) : null}

                {queueWaves.map((queueWave) => (
                    <RadioButton
                        key={queueWave.get('key')}
                        name="queueWave"
                        onChange={() =>
                            setSelectedQueueWave(queueWave.get('key'))
                        }
                    >
                        {queueWave.get('wave') === 0
                            ? i18next.t(
                                  'Queue.HandleMembers.DelayedHuntGroup.Default',
                              )
                            : `${i18next.t(
                                  'Queue.HandleMembers.DelayedHuntGroup',
                              )} ${queueWave.get('wave')}`}
                    </RadioButton>
                ))}
            </div>
        </BaseModal>
    );
};

export default AddQueueWaveMemberModal;
